
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <div class="topRect" :style="'background: linear-gradient(left bottom,'+GetColorMain()+','+GetColorMainGradual()+');background: -webkit-linear-gradient(left bottom,'+GetColorMain()+','+GetColorMainGradual()+');'">
      <div class="InfoRect">
        <div class="Money">
          {{ data.currency }} <span>{{ parseInt(data.payPrice) }}</span>.{{ parseInt((data.payPrice-parseInt(data.payPrice))*100) }}
        </div>
        <div class="MoneyType">
          {{ GetEnumText("Em_PayType",data.payType) }} {{ data.payType!=="WECHAT_PAY"?"(待确认)":"" }}
        </div>
      </div>
      <div class="successIcon">
        <i class="iconfont iconsuccess" />
      </div>
      <div class="downInfo">
        <van-row>
          <van-col span="12"> <div class="button" @click="onShowOrder()">查看订单</div></van-col>
          <van-col span="12"> <div class="buttonRigth" :style="'color: '+GetColorMain()" @click="onSecondButton">{{ data.buttonName?data.buttonName:"商城首页" }}</div></van-col>
        </van-row>
      </div>
    </div>
    <div class="noticeRect">
      注意：{{ GetSysTitle() }}及{{ GetSystemType() }}不会以订单异常、系统升级为由要求您点击任何网址链接进行退款操作。
    </div>
    <van-divider :style="{color: GetColorMain(), borderColor: GetColorMain(), padding: '0em 1em' }">为你推荐</van-divider>
    <div class="commodityList">
      <van-row>
        <van-col span="12">
          <div v-for="(item,index) in data.commodityList" :key="index" class="rect" @click="onGotoComment(item.commodityId)">
            <template v-if="index%2===0">
              <img :src="item.icon?item.icon+'?x-oss-process=style/commodityicon':'/img/defaultcom.jpg'">
              <div class="title breakAll">
                {{ item.name }}
              </div>
              <div class="price mainColor">
                ￥<span>{{ parseInt(item.price) }}</span>.{{ ("0"+parseInt((100*item.price+0.5-100*parseInt(item.price)))).slice(-2) }}
              </div>
            </template>
          </div>
        </van-col>
        <van-col span="12">
          <div v-for="(item,index) in data.commodityList" :key="index" class="rect" @click="onGotoComment(item.commodityId)">
            <template v-if="index%2===1">
              <img :src="item.icon?item.icon+'?x-oss-process=style/commodityicon': '/img/defaultcom.jpg'">
              <div class="title breakAll">
                {{ item.name }}
              </div>
              <div class="price mainColor">
                ￥<span>{{ parseInt(item.price) }}</span>.{{ ("0"+parseInt((100*item.price+0.5-100*parseInt(item.price)))).slice(-2) }}
              </div>
            </template>
          </div>
        </van-col>

      </van-row>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Divider } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText } from '@/utils/base'
import { GetSystemType } from '@/utils/request'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine, GetColorMainGradual } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Divider.name]: Divider,
    TopBar
  },
  data() {
    return {
      title: '支付成功',
      backurl: '/store/order/',
      id: undefined,
      list: [],
      data: {
        payPrice: 0,
        currency: 'CNY',
        payType: 'WECHAT_PAY',
        commodityList: []
      }
    }
  },

  created() {
    this.id = this.$route.params.id
    this.backurl = '/store/order/' + this.id
    this.initList()
  },
  methods: {
    GetSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetColorMainGradual,
    ShowMoney,
    GetEnumText,
    initList() {
      request({
        url: '/StoreHelper/getPayFinishPage',
        method: 'post',
        params: { orderId: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        if (this.data.isStepBuy) {
          if (this.data.isFirstPay) {
            this.title = '定金支付成功'
          } else {
            this.title = '尾款支付成功'
          }
        } else {
          this.title = '支付成功'
        }
      })
    },
    onGotoComment(id) {
      this.$router.push('/store/item/' + id)
    },
    onShowOrder() {
      this.$router.push(this.backurl)
    },
    onSecondButton() {
      if (this.data.buttonUrl) {
        this.$router.push(this.data.buttonUrl)
      } else {
        this.$router.push('/store/index/')
      }
    }
  }
}
</script>
<style scoped>
.topRect{
    height: 11em;
    position: relative;
}
.InfoRect{
    position: absolute;
    left: 2.5em;
    top:2em;
}
.InfoRect .Money{
    color: #fff;
    font-weight: 700;
    font-size:0.8em;
}
.InfoRect .Money span{
    font-size:2em;
}
.InfoRect .MoneyType{
    color: #fff;
    font-size: 0.7em;
}
.successIcon{
    position: absolute;
    right: 2.5em;
    top: 2em;
    width: 3em;
    height: 3em;
    line-height: 3em;
    text-align: center;
    border-radius: 3em;
    background-color: rgba(0,0,0,0.15);
}
.successIcon i{
    font-size: 2em;
    color: #fff;
}
.downInfo{
    position: absolute;
    left: 2.5em;
    right: 2.5em;
    top: 6.5em;
    border-top:1px dashed #fff;
    padding-top: 1em;
}
.downInfo .button{
    border:1px solid #fff;
    border-radius: 2em;
    width: 80%;
    padding: 0.5em;
    text-align: center;
    color: #fff;
    font-size: 0.8em;
}
.downInfo .buttonRigth{
    float: right;
    border:1px solid #fff;
    border-radius: 2em;
    width: 80%;
    padding: 0.5em;
    text-align: center;
    background-color: #fff;
    font-size: 0.8em;
}
.noticeRect{
    color: #999;
    font-size: 0.8em;
    padding: 0.5em 1em;
}
.commodityList{
  margin: 1em 0.75em;
}
.commodityList .rect{
  margin: 0.5em 0.25em;
  border-radius: 0.5em;
  background-color: #fff;
}
.commodityList .rect .title{
  padding: 0.5em 0.5em;
  font-size: 0.9em;
}
.commodityList .rect .price{
  padding:  0 0.5em 0.5em 0.5em;
  font-weight: 700;
  font-size: 0.9em;
}
.commodityList .rect .price span
{
  font-size: 1.2em;
}
.commodityList img{
  width: 100%;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
}
</style>
